import { on } from 'delegated-events'

const fn = {
  init: () => {
    on('click', '[data-full-modal]', fn.handleModalOpen)
    on('click', '.full-modal-close', fn.handleModalClose)
  },

  handleModalOpen: (e) => {
    const target = e.target.closest('[data-full-modal]').dataset.fullModal
    const el = document.querySelector(target)

    if (el) {
      el.classList.remove('opacity-0')
      el.classList.remove('pointer-events-none')
      document.documentElement.classList.add('overflow-hidden')
    } else {
      ajax
        .url(`/_modal/${target}`)
        .get()
        .text((resp) => {
          const modalId = Math.floor(Math.random() * 1000) + 1
          const node = document.createElement('div')
          node.id = `full-modal-${modalId}`
          node.innerHTML = resp

          document.body.appendChild(node)

          const el = node.querySelector('.full-modal')

          if (el) {
            setTimeout(() => {
              el.classList.remove('opacity-0')
              document.documentElement.classList.add('overflow-hidden')
            }, 16)
          }
        })
    }
  },

  handleModalClose: (e) => {
    const modal = e.target.closest('.full-modal')

    const isOnPage = modal.classList.contains('full-modal-on-page')

    if (isOnPage) {
      modal.classList.add('opacity-0', 'pointer-events-none')
      document.documentElement.classList.remove('overflow-hidden')
    } else {
      const node = modal.parentNode

      const el = node.querySelector('.full-modal')

      if (el) {
        el.classList.add('opacity-0')

        setTimeout(() => {
          document.documentElement.classList.remove('overflow-hidden')
          node.remove()
        }, 250)
      }
    }
  },
}

export default {
  can: () => true,
  run: fn.init,
}
